export const formatCurrency = (value: number, withDecimals = false) => {
	if (withDecimals) {
		return `${String(value.toFixed(2))
			.replace('.', ',')
			.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${String.fromCharCode(8239)}€`
	}

	return `${String(Math.round(value))
		.replace('.', ',')
		.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${String.fromCharCode(8239)}€`
}
